/* eslint-disable camelcase */
import $ from "jquery";

import { GoogleCharts } from "google-charts";

export default {
  init() {
    function drawChart() {
      // Get array from php and translate it number values to int
      function parseStringsToInt(array_php) {
        const label = array_php[0];
        const first = parseInt(array_php[1], 10);
        const second = parseInt(array_php[2], 10);
        const third = parseInt(array_php[3], 10);

        return [label, first, second, third];
      }

      const total_count_js = parseStringsToInt(window.total_count);
      const work_health_js = parseStringsToInt(window.work_health);
      const work_safety_js = parseStringsToInt(window.work_safety);
      const work_employee_js = parseStringsToInt(window.work_employee);
      const work_salary_js = parseStringsToInt(window.work_salary);
      const work_equality_js = parseStringsToInt(window.work_equality);
      const work_support_js = parseStringsToInt(window.work_support);
      const work_satisfaction_js = parseStringsToInt(window.work_satisfaction);
      const work_collaboration_js = parseStringsToInt(
        window.work_collaboration
      );
      const work_joy_js = parseStringsToInt(window.work_joy);
      const work_productivity_js = parseStringsToInt(window.work_productivity);
      const barchart_columns_js = window.barchart_columns;

      console.log(barchart_columns_js);

      const data = google.visualization.arrayToDataTable([
        barchart_columns_js,
        work_health_js,
        work_safety_js,
        work_employee_js,
        work_salary_js,
        work_equality_js,
        work_support_js,
        work_satisfaction_js,
        work_collaboration_js,
        work_joy_js,
        work_productivity_js
      ]);

      var view = new google.visualization.DataView(data);
      view.setColumns([
        0,
        1,
        {
          calc: "stringify",
          sourceColumn: 1,
          type: "string",
          role: "annotation"
        },
        2,
        {
          calc: "stringify",
          sourceColumn: 2,
          type: "string",
          role: "annotation"
        },
        3,
        {
          calc: "stringify",
          sourceColumn: 3,
          type: "string",
          role: "annotation"
        }
      ]);

      const options = {
        colors: ["#eb0089", "#f1f1f1", "#f9f9f9"],
        legend: { position: "none" },
        chartArea: { height: "100%" },
        annotations: {
          textStyle: {
            fontSize: 12,
            bold: true
          }
        },
        hAxis: {
          gridlines: { color: "#f1f1f1" }
        },
        vAxis: {
          textStyle: { color: "#9D9C9C", fontSize: 12 }
        },
        bar: { groupWidth: "95%" }
      };

      const chart = new google.visualization.BarChart(
        document.getElementById("chart")
      );

      chart.draw(view, options);
    }

    GoogleCharts.load(drawChart, { packages: ["corechart"] });
  },
  finalize() {
    // JavaScript to be fired on the about page, after the init JS
  }
};
